export const getInvoiceItemList = state => state.invoiceItem.invoiceItems || [];
